import { useState } from 'react';
import {
    useNavigate,
    useParams,
    useLocation
} from 'react-router-dom';

import { Header } from '@/presentation/components';
import { AppDrawer } from '@/presentation/components/layout/AppDrawer/AppDrawer';
import { BottomAppBar } from '@/presentation/components/layout/BottomAppBar/BottomAppBar';
import { useAuthContext } from '@/presentation/context';
import { routes } from '@/presentation/router';
import { CreateDialog } from './components/CreateActionDialog';
import { Form } from '@/presentation/components/Forms/Form/Form';

import { IncidenteSection } from './components/incidenteSection';
import { UsuariosSection } from './components/usuariosSection';
import { useVisita } from '@/presentation';
import { adelantarFecha } from '@/shared/utils/dateFormaters';

export default function ActionVisitaPage() {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    const { ubicacion_generica, fecha } =
        (location.state ?? {}) as { ubicacion_generica?: string; fecha?: string };


    const { user, logout } =
        useAuthContext();

    const [isDrawerOpen, setIsDrawerOpen] =
        useState(false);
    const { updateFecha } = useVisita();
    const [AdelantarOpen, setAdelantarOpen] = useState(false);

    const [posponerOpen, setPosponerOpen] = useState(false);
    const handleAdelantar = async (values: any) => {
        const valor = Number(values.valor)*-1;
        if (fecha === undefined) return;
        await updateFecha(String(id), { fecha: adelantarFecha(fecha, valor) });
        setAdelantarOpen(false);
        navigate(routes.visitas, { replace: true });
    }

    const handlePosponer = async (values: any) => {
        const valor = Number(values.valor);
        if (fecha === undefined) return;
        await updateFecha(String(id), { fecha: adelantarFecha(fecha, valor) });
        setPosponerOpen(false);
        navigate(routes.visitas, { replace: true });
    }



    const VisitaId = id ?? '0';

    const handleLogout = async () => {
        await logout();

        setIsDrawerOpen(false);

        navigate(routes.login, {
            replace: true,
        });
    };


    return (
        <div>
            <Header
                title={`Acciones en Visita ${ubicacion_generica}`}
                onMenuClick={() =>
                    setIsDrawerOpen(true)
                }
            />

            <AppDrawer
                isOpen={isDrawerOpen}
                user={user}
                onClose={() =>
                    setIsDrawerOpen(false)
                }
                onLogout={handleLogout}
            />
            <main style={{ padding: '24px' }}>
                <IncidenteSection
                    IncidenteId={VisitaId}
                />
                <UsuariosSection
                    IncidenteId={VisitaId}
                />

            </main>




            <BottomAppBar
                items={[
                    {
                        label: 'Adelantar',
                        onClick: () => {
                            setAdelantarOpen(true);
                        },
                        icon: undefined,
                    }, {
                        label: 'Posponer',
                        onClick: () => {
                            setPosponerOpen(true);
                        },
                        icon: undefined,
                    }

                ]}
            />

            <CreateDialog
                open={AdelantarOpen}
                title={`Adelantar de esta fecha: ${fecha}`}
                onClose={() => setAdelantarOpen(false)}
            >
                <Form
                    fields={[
                        {
                            name: 'valor',
                            type: 'number',
                            label: 'Cantidad de días',

                        },


                    ]}
                    submitLabel="Aceptar"

                    onSubmit={handleAdelantar}
                />
            </CreateDialog>
            <CreateDialog
                open={posponerOpen}
                title={`Posponer de esta fecha: ${fecha}`}
                onClose={() => setPosponerOpen(false)}
            >
                <Form
                    fields={[
                        {
                            name: 'valor',
                            type: 'number',
                            label: 'Cantidad de días',

                        },
                    ]}
                    submitLabel="Aceptar"

                    onSubmit={handlePosponer}
                />
            </CreateDialog>

        </div>
    );
}